export default __webpack_public_path__ + "static/media/Hero2.8bba005c.png";